<template>
  <component
    :is="tagName"
    :role="role"
    tabindex="-1"
    class="oct-menu"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: 'OctMenu',
  props: {
    /** Tag name */
    tagName: {
      type: String,
      default: 'ul'
    },
    /** Native role attribute */
    role: {
      type: [String, null],
      default: 'menu'
    },
  },
}
</script>

<style scoped lang="scss">
@import "../theme/variables";
@import "../grid/variables";
@import "../typography/variables";
@import "../typography/mixins";

.oct-menu {
  margin: 0;
  display: flex;
  flex-direction: column;
  padding: oct-rem(32 - 8) oct-rem(32) oct-rem(32 - 8);
  max-width: oct-rem(240);
  box-shadow: 0 0 oct-rem(20) 0 rgba(0, 0, 0, 0.10);
  background-color: $oct-theme--surface;
}
</style>
